<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row class="mb-4" align="center">
        <v-col cols="auto">
          <h2 v-if="serviceData && !duplicate">
            {{ $t("basics.edit", { type: $t("basics.service") }) }}
          </h2>
          <h2 v-else>
            {{ $t("basics.new", { type: $t("basics.service") }) }}
          </h2>
        </v-col>
      </v-row>

      <v-form ref="serviceEditForm">
        <!-- NAME -->
        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max256]" v-model="name"
              :label="$t('basics.name') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-combobox v-model="category" :items="availCategories" :label="$t('basics.categories')" variant="outlined"
              item-title="name" item-value="name" return-object :rules="[requiredRule, validObject]" autocomplete="off"
              :readonly="readonly"></v-combobox>
          </v-col>
        </v-row>

        <!-- NUMBER -->
        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max5]" v-model="number"
              :label="$t('basics.number') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <!-- PRICE MIN -->
        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat type="number" step="0.01" v-model="priceMin" :rules="[requiredRule]"
              :label="$t('basics.priceMin') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <!-- PRICE MAX -->
        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat type="number" step="0.01" v-model="priceMax" :rules="[requiredRule]"
              :label="$t('basics.priceMax') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat type="number" step="0.01" v-model="priceBill" :rules="[requiredRule]"
              :label="$t('basics.priceBill') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="6">
            <v-text-field variant="outlined" flat type="number" step="0.01" :rules="[requiredRule]" v-model="priceBill"
              :label="$t('basics.priceBill') + ' ' + $t('basics.net') + '*'" :readonly="readonly"
              @blur="validatePrice(); calcBrut()"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field variant="outlined" flat type="number" step="0.01" :rules="[requiredRule]"
              v-model="priceBrutto" :label="$t('basics.priceBill') + ' ' + $t('basics.brut') + '*'" :readonly="readonly"
              @blur="validatePrice(); calcNet()"></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mb-4 mt-0">
          <v-col class="pt-0">
            <small><i>**{{ $t("messages.psychotherpyServiceMessage") }}</i></small>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-select v-model="unit" :items="availBillUnits" :label="$t('basics.unit')" variant="outlined"
              :item-title="(item) => $t('constants.bill_unit_' + item.name)"
              :item-value="(item) => $t('constants.bill_unit_' + item.name)" return-object :rules="[requiredRule]"
              :readonly="readonly"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-checkbox class="hideDetails" :label="$t('messages.defaultBillService')" :readonly="readonly"
              v-model="defaultBill">
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-checkbox class="hideDetails" :label="$t('messages.markedService')" :readonly="readonly" v-model="marked">
            </v-checkbox>
          </v-col>
        </v-row>

        <!-- BUTTON -->
        <v-row v-if="!readonly">
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" ref="confirmButton" style="width: 100%"
              :loading="loading">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "serviceEditDrawer",
  props: ["serviceData", "refreshDisplay", "readonly", "duplicate"],
  emits: ["close"],

  data() {
    return {
      name: undefined,
      number: undefined,
      priceMin: undefined,
      priceMax: undefined,
      priceBill: undefined,
      priceBrutto: undefined,
      category: undefined,
      defaultBill: false,
      marked: false,
      unit: undefined,

      availCategories: undefined,
      availBillUnits: undefined,

      loading: false,

      requiredRule: (value) => value !== undefined || this.$i18n.t("messages.required"),
      validObject: (value) =>
        !value ||
        typeof value == "object" ||
        this.$i18n.t("messages.validSelectionrequired"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),
      max5: (value) =>
        !value || value.length <= 5 || this.$i18n.t("messages.tooLong", { count: 5 }),
      max5000: (value) =>
        !value ||
        value.length <= 5000 ||
        this.$i18n.t("messages.tooLong", { count: 5000 }),
    };
  },

  watch: {
    refreshDisplay() {
      this.loading = false
      this.fetchCategories().then(() => {
        this.fetchBillUnits().then(() => {
          this.setValues();
        })
      })
    },
  },

  methods: {
    fetchCategories() {
      return new Promise((resolve, reject) => {
        this.axios.get(this.axios.defaults.baseURL + "media/servicecategories/?size=10000")
          .then((resp) => {
            this.availCategories = resp.data.results

            resolve()
          })
          .catch((e) => {
            console.log(e)
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
            reject()
          })
      })
    },
    fetchBillUnits() {
      return new Promise((resolve, reject) => {
        this.axios.get(this.axios.defaults.baseURL + "media/billunits/")
          .then((resp) => {
            this.availBillUnits = resp.data

            resolve()
          })
          .catch((e) => {
            console.log(e)
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
            reject()
          })
      })
    },
    async confirm() {
      const { valid } = await this.$refs.serviceEditForm.validate();

      if (valid) {
        this.loading = true

        let formData = {};
        formData.name = this.name;
        formData.number = this.number;
        formData.price_min = this.priceMin;
        formData.price_max = this.priceMax;
        formData.price_bill = this.priceBill;
        formData.category = this.category.id
        formData.default_bill = this.defaultBill
        formData.marked = this.marked
        formData.unit = this.unit.key

        if (this.serviceData && !this.duplicate) {
          formData.id = this.serviceData.id;
          this.patchData(formData);
        } else {
          this.postData(formData);
        }
      }
    },

    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "media/services/post/", formData)
        .then(() => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },

    patchData(formData) {
      this.axios
        .patch(
          this.axios.defaults.baseURL + "media/services/patch/" + formData.id,
          formData
        )
        .then(() => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },

    calcNet() {
      console.log("net")
      if (!this.priceBrutto) {
        this.priceBill = 0
      }
      else {
        this.priceBill = +(this.priceBrutto / 1.19).toFixed(2);
      }
    },
    calcBrut() {
      console.log("brut")
      if (!this.priceBill) {
        this.priceBrutto = 0
      }
      else {
        this.priceBrutto = +(this.priceBill * 1.19).toFixed(2);
      }
    },

    validatePrice(val) {
      if (this.price > 99999) {
        this.price = 99999
      }
    },
    setValues() {
      if (this.serviceData) {
        this.name = this.serviceData.name;
        this.number = this.serviceData.number;
        this.priceMin = this.serviceData.price_min;
        this.priceMax = this.serviceData.price_max;
        this.priceBill = this.serviceData.price_bill;
        this.priceBrutto = +(this.serviceData.price_bill * 1.19).toFixed(2);
        this.category = this.serviceData.category
        this.defaultBill = this.serviceData.default_bill
        this.marked = this.serviceData.marked

        for (let i = 0; i < this.availBillUnits.length; i++) {
          if (this.serviceData.unit == this.availBillUnits[i].key) {
            this.unit = this.availBillUnits[i]
            break
          }
        }

        if (!this.unit) {
          this.unit = this.availBillUnits[0]
        }

      } else {
        this.name = undefined;
        this.number = undefined;
        this.priceMin = undefined;
        this.priceMax = undefined;
        this.priceBill = undefined;
        this.priceBrutto = undefined;
        this.category = undefined
        this.defaultBill = false
        this.marked = false

        this.unit = this.availBillUnits[0]
      }
    },
  },
};
</script>